// ─────────────────────────────────────────────────────────────────────
// WHERE THE API IS — one answer, importable without pulling in the transport.
//
// Split out of http.ts so the CLUB SESSION can read it too. The session signs
// in against the API, and the transport attaches the session's token: if both
// lived in http.ts the two modules would import each other. A base URL is not
// a transport concern anyway — it is configuration — so this is where it goes.
//
// `window.__VITE_API_URL__` rather than `import.meta.env`: vite.config.ts
// replaces that literal at build time (see its `define`), which is also how
// the Supabase values reach the bundle. Keeping the two the same shape means
// one mechanism to understand, not two.
// ─────────────────────────────────────────────────────────────────────

/** The API's base URL with no trailing slash, or '' when not in API mode. */
export function apiBaseUrl(): string {
  try {
    if (typeof window !== 'undefined' && window.__VITE_API_URL__) {
      return window.__VITE_API_URL__.replace(/\/$/, '');
    }
  } catch {
    /* no window — not in API mode */
  }
  return '';
}

/**
 * Is the app talking to the API at all?
 *
 * Deliberately derived from the base URL rather than from `Storage.backend`.
 * The two are the same condition (storage.ts picks `http` exactly when
 * VITE_API_URL is set), but importing Storage here would make the module graph
 * circular — storage.ts is itself a caller.
 */
export function isApiMode(): boolean {
  return apiBaseUrl() !== '';
}
